import React from 'react';
import {
  User, Phone, Mail, Lock, HeartHandshake, Wallet, Home, FileUp, PenLine,
  MapPin, LogIn, PartyPopper, Repeat2, ScrollText, Sparkles, Star,
  CreditCard, CalendarDays
} from 'lucide-react';

// One small lucide icon per "theme" — kept intentionally simple (just an SVG
// icon, no custom illustration assets) so it renders instantly with zero
// asset-loading lag, while still feeling warm thanks to the CSS-only
// float/glow/sparkle motion below.
const ICONS = {
  name: User,
  phone: Phone,
  email: Mail,
  password: Lock,
  consent: HeartHandshake,
  login: LogIn,
  celebrate: PartyPopper,
  money: Wallet,
  home: Home,
  documents: FileUp,
  notes: PenLine,
  location: MapPin,
  journey: Repeat2,
  declaration: ScrollText,
  id: CreditCard,
  date: CalendarDays,
};

/**
 * A tiny, playful "hero" for each slide of a step-by-step form — a soft
 * glowing circle with a floating icon and a couple of twinkling sparkles.
 * Pure CSS animation (no JS/animation libraries), so it's instant and cheap.
 */
export default function SlideHero({ icon = 'name' }) {
  const Icon = ICONS[icon] || User;
  return (
    <div className="relative mx-auto mb-1 flex h-24 w-24 items-center justify-center" aria-hidden="true">
      {/* Soft glow backdrop */}
      <div className="slide-hero-glow absolute inset-0 rounded-full bg-primary/25 blur-xl" />
      {/* Main circle + icon — gentle float */}
      <div className="slide-hero-float relative flex h-[76px] w-[76px] items-center justify-center rounded-full border border-primary/20 bg-primary/10">
        <Icon className="h-8 w-8 text-primary" strokeWidth={1.75} />
      </div>
      {/* Twinkling sparkles */}
      <Sparkles
        className="slide-hero-sparkle absolute -right-1 -top-1 h-5 w-5 text-accent"
        strokeWidth={2}
      />
      <Star
        className="slide-hero-sparkle absolute -bottom-0.5 -left-2 h-3.5 w-3.5 text-primary/70"
        strokeWidth={2}
        style={{ animationDelay: '0.7s' }}
      />
    </div>
  );
}
